import React, { useState } from "react";
import "./DSInfo.css";
import { Link, useNavigate } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { handleNextPage } from "./DSFunction";
import { saveAsDraft } from "../RoofSelection/roofFunction";
import { useSelector, useDispatch } from "react-redux";
import CanvasDataDetails from "./DSCanvas/canvasDataDetails";
import Canvas from "./DSCanvas/canvas";
import DSInfoContainer from "./DSInfoContainer";
import { resetDesignParameter } from "../../../Features/designParameter";
import { updateQuantityInfo } from "../../../Features/quantityInfo";
// import { updateUserInfo } from "../../../Features/userInfo";
import { ProjectApi } from "../../../apis";

export default function DSInfo({ setLoader, mapRef }) {
  const navigate = useNavigate();
  const ProjectRouter = ProjectApi();
  const roofInfo = useSelector((state) => state.roof);
  const quantityInfo = useSelector((state) => state.quantity);
  // const userInfo = useSelector((state) => state.user);
  const conUser = useSelector((state) => state?.conUser);
  const reportInfo = useSelector((state) => state?.reportInfo);

  const user = conUser?.user;
  const [selectedImage, setSelectedImage] = useState([]);
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const [currentPos, setCurrentPos] = useState([]);
  const [startPos, setStartPos] = useState([]);
  const [isDrawing, setIsDrawing] = useState(false);
  const [zoomValue, setZoomValue] = useState(1);
  const [drag, setDrag] = useState(false);
  const [dragPos, setDragPos] = useState({ x: 0, y: 0 });
  const [points, setPoints] = useState([]);
  const [draftLoader, setDraftLoader] = useState(false);

  // const [iconInfo, setIconInfo] = useState(!userInfo.checkInfo);
  // const handleCloseInfo = () => setIconInfo(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const boxDimension = roofInfo?.value?.boxDimension
    ? roofInfo.value.boxDimension
    : [];

  // const handleCheck = async () => {
  //   try {
  //     dispatch(updateUserInfo({ checkInfo: true }));
  //     setIconInfo(false);
  //   } catch (error) {
  //     console.error("Error updating or adding document: ", error);
  //   }
  // };

  return (
    <>
      <div className="ds-Info">
        <div className="mainInfoBox">
          <DSInfoContainer
            setDrag={setDrag}
            setPoints={setPoints}
          ></DSInfoContainer>
          <div className="mapContainer" style={{ overflow: "hidden" }}>
            <h1>Configure your desired structure</h1>
            <div
              className="MapBox"
              style={{
                position: "relative",
                width: `${boxDimension.width}px`,
                height: `${boxDimension.height}px`,
                borderRadius: "40px !important",
                background: "whitesmoke",
              }}
            >
              <div className="canvasDetail">
                <CanvasDataDetails
                  setSelectedImage={setSelectedImage}
                  selectedImage={selectedImage}
                  setZoomValue={setZoomValue}
                  zoomValue={zoomValue}
                  setDragPos={setDragPos}
                  dragPos={dragPos}
                  setDrag={setDrag}
                  setPoints={setPoints}
                />
              </div>
              <div ref={mapRef} className="canvas">
                <Canvas
                  selectedImage={selectedImage}
                  setSelectedImage={setSelectedImage}
                  startPos={startPos}
                  setStartPos={setStartPos}
                  currentPos={currentPos}
                  setCurrentPos={setCurrentPos}
                  isDrawing={isDrawing}
                  setIsDrawing={setIsDrawing}
                  zoomValue={zoomValue}
                  setZoomValue={setZoomValue}
                  setDragPos={setDragPos}
                  dragPos={dragPos}
                  drag={drag}
                  points={points}
                  setPoints={setPoints}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="containerButton">
          <div className="rightButton">
            <Link to="/analytics">
              <button className="backButton">
                <i className="bi bi-chevron-double-left"></i> Back
              </button>
            </Link>
          </div>
          <div className="rightButton">
            <button onClick={handleShow}>Save as Draft</button>
            <button
              className="nextButton"
              onClick={() => {
                dispatch(resetDesignParameter());
                dispatch(updateQuantityInfo({ allRoof: true }));
                setTimeout(() => {
                  handleNextPage({
                    dispatch,
                    roofInfo,
                    mapRef,
                    setLoader,
                    navigate,
                    quantityInfo,
                  });
                }, 100);
              }}
            >
              Next <i className="bi bi-chevron-double-right"></i>
            </button>
          </div>
        </div>
      </div>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Discard Changes</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to stop editing? You can save this project as
          draft and can continue later.
        </Modal.Body>
        <Modal.Footer>
          {draftLoader && (
            <div className="draftLoader">
              <div className="ring"></div>
              <img src="./images/Logos/flash.svg" alt="logo"></img>
            </div>
          )}
          <Button
            variant="secondary"
            onClick={() =>
              saveAsDraft({
                ProjectRouter,
                setDraftLoader,
                navigate,
                roofInfo,
                quantityInfo,
                user,
                reportInfo,
              })
            }
          >
            Save as Draft
          </Button>
          <Button variant="primary" onClick={handleClose}>
            Discard
          </Button>
        </Modal.Footer>
      </Modal>
      
      {/* <Modal
        show={iconInfo}
        onHide={handleCloseInfo}
        backdrop="static"
        keyboard={false}
        centered
        className="actionModal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Icons Description</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              display: "flex",
              gap: "20px",
              marginBottom: "10px",
            }}
          >
            <h6 style={{ fontSize: "14px", color: "#27326a" }}>
              {" "}
              To draw a roof in the required area, please click on the provided
              icon
            </h6>
            <img
              src="../images/icons/polygonAdd.svg"
              alt="Add Obstacle"
              style={{ width: "30px" }}
            ></img>
          </div>
          <div
            style={{
              display: "flex",
              gap: "20px",
            }}
          >
            <h6 style={{ fontSize: "14px", color: "#27326a" }}>
              {" "}
              To draw an obstacle/hurdle in the roof area, please click on
              the provided icon
            </h6>
            <img
              src="../images/icons/addObstacle.svg"
              alt="Add Obstacle"
              style={{ width: "30px" }}
            ></img>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="checkBox">
            <input type="checkbox" onClick={() => handleCheck()}></input>
            <h6>Don't show again</h6>
          </div>
        </Modal.Footer>
      </Modal> */}
    </>
  );
}
